import styled from "styled-components";
import { TableCell } from "@mui/material";

export const Container = styled.div``;

export const AreaStatus = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
`;

export const EllipsisCell = styled(TableCell)`
	&&& {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;
